import React, { useState, useRef, useEffect } from "react";
import { SERVER_URL, NEW_PRINT } from "../config/config";
import { useHistory } from "react-router-dom";

export default function BranchSelector({ sessionObject, mainBranchSelector, subMenuItemsDict, setSubMenuItemsDict, setItemNamesDict }) {
    const [currentYear, setCurrentYear] = useState("");
    const [yearIndex, setYearIndex] = useState("");
    const [dateSelectorObj, setDateSelectorObj] = useState([]);
    const history = useHistory();

    const refStoreObject = useRef({
        branch_select: null,
        year_select: null,
        save_button: null,
    });
    var branch_info = sessionStorage.getItem("branch_info");
    var branch_info_1 = JSON.parse(branch_info)["branch_info"];
    const [branchInfo, setBranchInfo] = useState({
        branch_id: branch_info_1[0].branch_id,
        branch_name: branch_info_1[0].branch_name,
        branch_account_name: branch_info_1[0].account_name,
        branch_account_id: branch_info_1[0].account_id,
        branch_suffix: branch_info_1[0].suffix,
    });

    const fetchData = async () => {
        try {
            const response = await fetch(`${NEW_PRINT}/bilty/get_module_json/?client_name=${process.env.REACT_APP_CLIENT}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "client_name": process.env.REACT_APP_CLIENT }),
                redirect: 'follow'
            });
    
            const result = await response.json();
            let filteredModules = [...result.Modules];
            if(process.env.REACT_APP_CLIENT == "shubham") {
                if(sessionObject.sessionVariables.role_id !== 1) {
                    filteredModules = filteredModules.filter(module => module.name !== "Bill Entry");
                }
            }
            if(process.env.REACT_APP_CLIENT == "gdala_log") {
                if(sessionObject.sessionVariables.role_id !== 1) {
                    filteredModules = filteredModules.filter(module => module.name !== "Station Wise Summary");
                }
            }
            setSubMenuItemsDict({ ...result, Modules: filteredModules });
        } catch (error) {
            console.log('error', error);
        }
    };

    const fetchItemNames = async () => {
        try {
            const response = await fetch(`${SERVER_URL}/pack_type/`);
            const result = await response.json();
            setItemNamesDict(result);
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(()=> {
        fetchData();
        fetchItemNames();
        },[])
        
    const handleSubmit = async (e) => {
        e.preventDefault();

        let financialYearObj = {
            financial_year: yearIndex,
        }

        if (mainBranchSelector) {
            financialYearObj.financial_year_for_fetch = yearIndex;
        }

        sessionObject.saveSessionVariableByObject({
            ...branchInfo,
            ...financialYearObj,
        });

        history.push("/");
    };

    const handleChange = function (e, selectName) {
        const { name, value } = e.target;
        let curr_branch_id = value;
        for (let i = 0; i < branch_info_1.length; i++) {
            if (branch_info_1[i].branch_id == curr_branch_id) {
                setBranchInfo({
                    branch_id: value,
                    branch_name: branch_info_1[i].branch_name,
                    branch_account_name: branch_info_1[i].account_name,
                    branch_account_id: branch_info_1[i].account_id,
                    branch_suffix: branch_info_1[i].suffix,
                });
            }
        }
    };

    useEffect(
        () => {
            refStoreObject.current.branch_select?.focus();
        },
        []
    );

    useEffect(() => {

        let selectorObj = [];

        const currDate = new Date();
        let currMonth = currDate.getMonth() + 1;
        let currYear = currDate.getFullYear().toString().substring(2) - (currMonth < 4);

        let yearRange = 2;
        let isCurrentYearSet = false;

        if (currYear == "21") {
            selectorObj.push({
                value: "22-23",
                label: "01/04/2022 - 31/03/2023",
            });
        }

        for (let i = 0; i < yearRange; i++) {
            let temp1 = currYear - i;
            let temp2 = temp1 + 1;
            let tempObj = {
                value: temp1 + "-" + temp2,
                label: "01/04/20" + temp1 + " - " + "31/03/20" + temp2,
            };

            if (!isCurrentYearSet) {
                isCurrentYearSet = true;
                setCurrentYear(temp1 + "-" + temp2);
                setYearIndex(temp1 + "-" + temp2);
            }

            selectorObj.push(tempObj);
        }
        setDateSelectorObj(selectorObj);
    }, [])

    const wrapper = {
        height: "calc(100vh - 80px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
        fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, Arial",
        padding: "20px",
        boxSizing: "border-box",
    };

    const card = {
        width: "320px",
        background: "#fff",
        padding: "30px 26px",
        borderRadius: "12px",
        border: "1px solid #e3e6ea",
        boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
        textAlign: "center",
        boxSizing: "border-box",
    };

    const icon = {
        width: "48px",
        height: "48px",
        margin: "0 auto 8px auto",
        borderRadius: "50%",
        background: "#eef0f7",
        color: "#43507d",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "26px",
        fontWeight: 700,
        lineHeight: 1,
    };

    const title = {
        fontSize: "20px",
        fontWeight: 600,
        marginBottom: "3px",
        color: "#222",
    };

    const subTitle = {
        fontSize: "13px",
        color: "#666",
        marginBottom: "25px",
    };

    const selectBox = {
        width: "100%",
        padding: "10px 12px",
        borderRadius: "8px",
        border: "1px solid #d1d5db",
        background: "#fbfbfd",
        marginBottom: "30px",
        fontSize: "16px",
        cursor: "pointer",
        outline: "none",
        boxSizing: "border-box",
        fontFamily: "inherit",
    };

    const submitBtn = {
        width: "100%",
        background: "#43507d",
        padding: "12px 0",
        borderRadius: "8px",
        border: "none",
        color: "white",
        fontSize: "16px",
        fontWeight: 600,
        cursor: "pointer",
        outline: "none",
        transition: "0.15s ease",
        fontFamily: "inherit",
    };

    return (
        <div style={wrapper}>
            <div style={card}>
                <div style={icon}>🏦</div>
                <div style={title}>Select Branch</div>
                <div style={subTitle}>Choose your branch and year</div>

                <form onSubmit={handleSubmit}>
                <select
                    style={selectBox}
                    onChange={(newValue) => {
                        handleChange(newValue);
                    }}
                    ref={(a) => (refStoreObject.current.branch_select = a)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            refStoreObject.current.year_select.focus();
                        }
                    }}
                    onFocus={(e) => {
                        e.target.style.border = "1px solid #43507d";
                        e.target.style.boxShadow = "0 0 0 2px rgba(67,80,125,0.20)";
                    }}
                    onBlur={(e) => {
                        e.target.style.border = "1px solid #d1d5db";
                        e.target.style.boxShadow = "none";
                    }}
                >
                    {branch_info_1.map((branch) => (
                        <option value={branch["branch_id"]} key={branch["branch_name"]}>
                            {branch.branch_name}
                        </option>
                    ))}
                </select>

                <select
                    style={{
                        ...selectBox,
                        color: yearIndex === currentYear ? "#111" : "#dc2626",
                    }}
                    value={yearIndex}
                    onChange={(e) => {
                        setYearIndex(e.target.value)
                    }}
                    ref={(a) => (refStoreObject.current.year_select = a)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            refStoreObject.current.save_button.focus();
                        }
                    }}
                    onFocus={(e) => {
                        e.target.style.border = "1px solid #43507d";
                        e.target.style.boxShadow = "0 0 0 2px rgba(67,80,125,0.20)";
                    }}
                    onBlur={(e) => {
                        e.target.style.border = "1px solid #d1d5db";
                        e.target.style.boxShadow = "none";
                    }}
                >
                    {dateSelectorObj.map((date) => (
                        <option
                            value={date["value"]}
                            key={date["value"]}
                            style={{
                                color: date.value == currentYear ? "black" : "red",
                            }}
                        >
                            {date.label}
                        </option>
                    ))}
                </select>
                
                <button
                    style={submitBtn}
                    type="submit"
                    ref={(a) => (refStoreObject.current.save_button = a)}
                    onMouseEnter={(e) => (e.target.style.background = "#363f63")}
                    onMouseLeave={(e) => (e.target.style.background = "#43507d")}
                    onFocus={(e) => {
                        e.target.style.boxShadow = "0 0 0 2px rgba(67,80,125,0.25)";
                    }}
                    onBlur={(e) => {
                        e.target.style.boxShadow = "none";
                    }}
                >
                    Submit
                </button>
                </form>
            </div>
        </div>
    );
}
